import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { GestorStatusService } from '../gestor-status.service';
import * as backInter from 'app/auth/auth-data.model';

import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.scss'],
  animations : fuseAnimations
})
export class ProductoComponent implements OnInit {

  idEmpresa: string;
  productosFiltrados: any[] = [];
  producto: string;

  constructor(
    private router: Router,
    private _fuseSidebarService: FuseSidebarService,
    private wizardService: WizardService,
    private gestorStatService: GestorStatusService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    // this.idEmpresa = this.router.getCurrentNavigation().extras.state.idEmpresa;
    // this.productosFiltrados = this.router.getCurrentNavigation().extras.state.productosFiltrados;
    // this.producto = this.router.getCurrentNavigation().extras.state.producto;
    this.idEmpresa = localStorage.getItem('empresaIDInfo');
    this.producto = localStorage.getItem('tipoProdInfo');
    // console.log(this.productosFiltrados);
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.obtieneProductos();
  }

  obtieneProductos(){
    this.wizardService.getProductosEmpresa(this.idEmpresa).subscribe( (respuesta: backInter.infoProductos) => {
      switch(this.producto){
        case 'certify': this.productosFiltrados = respuesta.productosCertificar; break;
        case 'measurement': this.productosFiltrados = respuesta.productosMedir; break;
        case 'pulse': this.productosFiltrados = respuesta.productosPulseCheck; break;
        case 'focus': this.productosFiltrados = respuesta.productosFocusArea; break;
      }
      this.gestorStatService.puenteDatos(this.productosFiltrados);
    });
  }

  toggleSidebar(name): void
  {
      this._fuseSidebarService.getSidebar(name).toggleOpen();
  }

}
